import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect } from '@ngrx/effects';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { of } from 'rxjs/observable/of';
import { User } from '../../shared/models/user';

import { AuthService } from '../../shared/services/auth.service';
import * as Login from '../actions/login';

@Injectable()
export class LoginEffects {
  @Effect({dispatch: false})
  error$ = this.actions$.ofType(Login.ERROR).map(a => a);
  @Effect()
  login$ = this.actions$
    .ofType(Login.LOGIN)
    .map((action: Login.Login) => action.payload)
    .exhaustMap(auth => {
        return this.authService.login(auth)
          .map((user: User) => new Login.LoginSuccess({user}))
          .catch(error => of(new Login.LoginFailure(error)));
      },
    );
  @Effect({dispatch: false})
  loginRedirect$ = this.actions$
    .ofType(Login.SELECT_METHOD)
    .do((authed: Login.SelectMethod) => {
      switch (authed.payload) {
        case 'email':
          return this.router.navigate(['/auth/login/email']);
        case 'sms':
          return this.router.navigate(['/auth/login/sms']);
      }
    });
  @Effect({dispatch: true})
  loginSms$ = this.actions$
    .ofType(Login.LOGIN_SMS)
    .map((action: Login.LoginSms) => action.payload)
    .switchMap(auth => this.authService.loginSms(auth)
      .map((user: User) => {
        if (!user.uid) {
          return new Login.CaptchaSuccess(user);
        } else {
          return new Login.LoginSmsSuccess({user});
        }
      })
      .catch(error => of(new Login.LoginSmsFailure(error))),
    ).map(a => a).catch(error => of(new Login.LoginSmsFailure(error)));
  @Effect({dispatch: false})
  loginSuccess$ = this.actions$
    .ofType(Login.LOGIN_SUCCESS, Login.LOGIN_SMS_SUCCESS)
    .do(() => {
      // this.authService.logout();
      this.router.navigate(['/account']);
    });
  @Effect()
  logout$ = this.actions$
    .ofType(Login.LOGOUT)
    .exhaustMap(auth => {
        return this.authService.logout()
          .map((user: User) => new Login.LogoutSuccess())
          .catch(error => of(new Login.LogoutFailure(error)));
      },
    );
  @Effect({dispatch: false})
  selectMethod$ = this.actions$
    .ofType(Login.LOGIN_REDIRECT, Login.LOGOUT_SUCCESS)
    .do(authed => {
      this.router.navigate(['/auth/login/email']);
    });


  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
  ) {
  }
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/effects/login.effects.ts